/**
 * API Endpoints Configuration
 * 
 * This file maps frontend API requests to backend database tables
 * and provides configuration for API endpoints based on actual database structure.
 */

// Base API URL paths
export const API_PATHS = {
  // Campaign data (Campaigns table)
  CAMPAIGNS: '/campaigns-data/',
  
  // User management
  USERS: '/users/',
  ROLES: '/roles-mng/',
  PERMISSIONS: '/permissions/',
  
  // Reference data (dimension tables)
  LEGEND: '/legend/',
  BRANDS: '/category/brands/',                // maps to dim_brand table
  SUB_BRANDS: '/category/sub-brands/',        // maps to dim_sub_brand table
  MEDIA_TYPES: '/category/media-types/',     // maps to dim_media_type_channel
  STATUSES: '/category/statuses/',           // maps to dim_status
  DIGITAL_VENDORS: '/category/vendors/',     // maps to dim_digital_vendor
  DIGITAL_AD_FORMATS: '/category/digital-ad-formats/', // maps to dim_digital_ad_format
  OOH_FORMATS: '/category/ooh-formats/',     // maps to dim_ooh_format
  ASSET_TYPES: '/category/asset-types/',     // maps to dim_asset_video_length_image_type
  AGENCIES: '/category/agencies/',           // maps to dim_agency
  CAMPAIGN_TYPES: '/category/campaign-types/', // maps to dim_campaign_type
  OBJECTIVES: '/category/objectives/',         // maps to dim_objective
  SUB_MEDIA_TYPES: '/category/sub-media-types/', // maps to dim_sub_media_type
  
  // Campaign detail tables
  MEDIA_TYPES_BY_CAMPAIGN: (campaignId) => `campaigns-data/${campaignId}/media-types/`,
  ACCRUAL_DETAIL: (campaignId) => `campaigns-data/${campaignId}/accrual-detail/`,
  
  // Dashboard and snapshot endpoints
  DASHBOARD_METRICS: '/dashboard/metrics/',
  BRAND_SUMMARIES: '/reports/brand-summaries/',
  CAMPAIGN_REGIONAL_BREAKDOWN: '/reports/campaign-regional-breakdown/',
  SNAPSHOT_MONTHS: '/system/snapshot/months/',
  SNAPSHOT_BY_MONTH: '/system/snapshot/',
  
  // Performance tab endpoints - updated to use existing backend endpoints
  CHANNEL_SUMMARIES: '/reports/channel-summaries/',
  VARIANCE_RECORDS: '/reports/variance-records/',
  MONTHLY_DATA: '/reports/monthly-data/',
};

// Database field mapping - maps UI fields to database column names
export const DB_FIELD_MAPPING = {
  // Campaign fields
  campaign: {
    id: 'id',
    name: 'campaign_name',
    brand: 'brand_id',
    subBrand: 'sub_brand_id',
    objective: 'objective',
    startDate: 'start_date',
    endDate: 'end_date',
    status: 'campaign_status'
  },
  
  // Reference data fields
  brand: {
    id: 'brand_id',
    name: 'brand_name',
    key: 'brand_key'
  },
  
  subBrand: {
    id: 'sub_brand_id',
    name: 'sub_brand_name',
    key: 'sub_brand_key',
    brandId: 'brand_id'
  },
  
  mediaType: {
    id: 'media_type_channel_id',
    name: 'media_type_channel_name'
  },
  
  status: {
    id: 'status_id',
    code: 'status_code',
    name: 'status_name'
  }
};

// Status code mapping (for consistency between UI and backend)
export const STATUS_CODES = {
  PLANNING: 'planning',
  ONGOING: 'on-going',
  DONE: 'done'
};

export default {
  API_PATHS,
  DB_FIELD_MAPPING,
  STATUS_CODES
}; 